import {
  queryAddEditField,
  queryAddNewField,
  queryDeleteItem,
  queryEditItemField,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'processCustomListField',
  state: {
    newField: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,order,displayText,type,isFilterEnabled',
    notSelectSearch: 'order,isFilterEnabled,type',
    expand: {
      form: { select: 'name' },
    },
    paramsView: {
      select: 'id,order,displayText,type,isFilterEnabled,isDefaultSortingColumn,created,updated,',
      expand: {
        form: { select: 'name' },
        field: { select: 'displayText' },
        variable: { select: 'internalName' },
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },
    paramsEdit: {
      select:
        'id,order,displayText,type,isFilterEnabled,isDefaultSortingColumn,formFieldValueSource,formId,fieldId,variableId',
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
    searchCriteria: '',
    isActive: '',
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryFields',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewField({ payload }, { put }) {
      yield put({
        type: 'addField',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewField',
          payload,
        });
      }
    },

    *editItemField({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemField, payload);
        yield put({
          type: 'editField',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewField({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewField, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveField',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditField({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditField, payload.data);
        yield put({
          type: 'global/showFieldsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveField',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ payload }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, payload.id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveField',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${payload.view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: payload.view,
            },
          });
        }
      }
    },

    *showItemField({ view }, { put }) {
      yield put({
        type: 'showEditItemField',
        view,
      });
    },

    *isActive({ payload }, { put }) {
      yield put({
        type: payload.type,
        payload: payload.value,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *search({ payload }, { put }) {
      yield put({
        type: payload.type,
        payload: payload.str,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryFields(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addField(state, { payload }) {
      return {
        ...state,
        newField: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewField(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editField(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveField(state, { payload }) {
      return {
        ...state,
        saveField: payload,
        newField: false,
        selectedItem: false,
      };
    },

    showEditItemField(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    stateFields(state, { payload }) {
      return {
        ...state,
        isActive: payload,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    searchFields(state, { payload }) {
      return {
        ...state,
        searchCriteria: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newField: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
        searchCriteria: '',
        isActive: '',
      };
    },
  },
};

export default Model;
